export enum StockCountTabs {
  PENDING = "pending",
  COMPLETED = "completed",
}
